import {
  DecisionContext,
  DecisionTypeHandler,
  DbotEventDispatcher,
} from "@/dbot/common/commonDomain";
import {
  ElectNominationCommittee,
  ElectNominationCommitteeForm,
} from "./electNominationCommitteeDomain";
import { DecisionType } from "@/common/decisions";

export function initNewForm(
  dispatch: DbotEventDispatcher,
  context: DecisionContext<ElectNominationCommittee>,
  data?: ElectNominationCommittee,
): ElectNominationCommitteeForm {
  return new ElectNominationCommitteeForm(dispatch, context, data);
}

export function isValid(form: ElectNominationCommitteeForm): boolean {
  return form.isValid;
}

export function validate(form: ElectNominationCommitteeForm): boolean {
  return form.validate();
}

export function applyForm(form: ElectNominationCommitteeForm): ElectNominationCommittee {
  return {
    type: DecisionType.electNominationCommittee,
    newNominationCommitteeMembersByName: form.filterSelected(),
  };
}

export const electNominationCommitteeHandler: DecisionTypeHandler<
  DecisionType.electNominationCommittee,
  ElectNominationCommittee,
  ElectNominationCommitteeForm
> = {
  type: DecisionType.electNominationCommittee,
  initNewForm,
  isValid,
  validate,
  applyForm,
};
